import SimpleFormPage from "../common/SimpleFormPage";
import EmployeeFields from "./EmployeeFields";

export default function NewEmployee() {
  return (
    <SimpleFormPage title="Nuovo dipendente">
      <EmployeeFields />
    </SimpleFormPage>
  );
}
